<template>
    <div :class="['hpLoc','spOpen']">
        <div @click="closeMap" class="closebtn"></div>
        <iframe src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d59597.0124618449!2d-86.88471260797508!3d21.000120627704252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x8f4e8047678409bf%3A0x5fd4feaf78eabb92!2sCancun%20International%20Airport%20(CUN)%2C%20Cancun%20-%20Chetumal%2C%20Canc%C3%BAn%2C%20Quintana%20Roo%2C%20Mexico!3m2!1d21.041703299999998!2d-86.8740062!4m5!1s0x8f4e86bbc7183c17%3A0x7d452b4b7f19bed!2sHilton%20Cancun%2C%20an%20All-Inclusive%20Resort%2C%20Carr%20Federal%20Libre%20307%20Cancun-Tulum%20Km%20248-868%2C%20SM-36%2C%20LT-1-01%20UPE-1E%2C%2077580%20Canc%C3%BAn%2C%20Q.R.%2C%20Mexico!3m2!1d20.955542899999998!2d-86.8361439!5e0!3m2!1sen!2sil!4v1656824534436!5m2!1sen!2sil" 
        width="100%"
        style="border:0;" 
        allowfullscreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
</template>

<style scoped>
  .hpLoc
  {
        position: fixed;
        width: 100vw;height: 100vh;
        top: 0px;
        left: 0px;
        overflow: hidden;
        background-color: #fff;
        z-index: 1002;
        display: grid;
        align-items: center;
        text-align: center;
        opacity: 1;
        clip-path: inset(0px 0px 100% 0px);
        transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000);
        pointer-events: none;
        display: grid;
  }
  .hpLoc .closebtn
  {
    position: absolute;
    top: 2vw;
    right:3vh;
  }
  .hpLoc.spOpen
  {
      pointer-events: all;
      opacity: 1;
      clip-path: inset(0px 0px 0px 0px);
  }
    .hpLoc iframe
    {
        height: 100%;
        width: 100%;
        padding: 80px;
    }


        @media (hover: hover) {

        }    
      @media (max-width: 850px) { 
        .hpLoc
        {
            width: 100vw !important;
            height: 100vh !important;
            top: 0px !important;
            left: 0px !important;
        }    
        .hpLoc iframe
        {
            height: 100%;
            width: 100%;
            padding: 60px 30px;
        }                
        .hpLoc .closebtn
        {
            position: absolute;
            top: 3vh;
            right:3vh;
        }
        }

        /* Portrait iPad mini 1, iPad 1 and iPad 2*/
        @media only screen 
        and (min-device-width: 768px) 
        and (max-device-width: 1024px) 
        and (-webkit-min-device-pixel-ratio: 1) 
        and (orientation: portrait)
        {
            .hpLoc iframe {padding: 80px 60px;}            
        }

        /* Landscape iPad mini 1, iPad 1 and iPad 2 */
        @media only screen 
        and (min-device-width: 768px) 
        and (max-device-width: 1024px) 
        and (-webkit-min-device-pixel-ratio: 1) 
        and (orientation: landscape)
        {

        }      
</style>
<script>
    export default {
        props: {
            isMapOpen: Boolean,
        },
        mounted()
        {
            isMapOpen=false;
        },
        methods:
        {
            closeMap()
            {
                this.$emit("close-map");
            }
        },
        data()
        {
            return {
                isOpen:true
            }
        }
    }
</script>  
